/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import {
  TouchableOpacity,
  View,
  Text,
  ActivityIndicator,
  StyleSheet,
  Platform,
} from 'react-native'
import { actionContextTypes } from '../../utils/actions'
import { getShadowStyles } from '../../utils/styles'
import { normalizeFontFamily, translateFontWeight } from '../../utils/type'
import ActionWrapper from '../ActionWrapper'

const DEFAULT_PROPS = {
  backgroundColor: '#6200ee',
  color: '#fff',
  borderColor: '#999',
  borderWidth: 0,
  borderRadius: 4,
  fontSize: 14,
  fontWeight: 400,
  fontFamily: '@body',
  padding: 10,
}

const getStyles = (props, appBranding) => {
  const {
    color,
    backgroundColor,
    borderRadius,
    borderColor,
    borderWidth,
    shadow,
    fontSize,
    fontWeight,
    fontFamily,
    padding,
    submitting,
  } = props

  const wrapperStyles = {
    ...getShadowStyles(shadow),
    backgroundColor,
    borderRadius,
    borderWidth,
    borderColor,
    height: fontSize * 1.4 + 2 * padding,
    opacity: submitting ? 0.5 : 1,
  }

  const textStyles = {
    color,
    fontSize,
    fontWeight:
      Platform.OS !== 'android'
        ? translateFontWeight(fontWeight, fontFamily, appBranding)
        : null,
    fontFamily: normalizeFontFamily(fontFamily, appBranding, { fontWeight }),
  }

  return { textStyles, wrapperStyles }
}

const ButtonProgressIndicator = () => (
  <View style={styles.submitProgress}>
    <ActivityIndicator color="#999999" />
  </View>
)

export class SubmitButton extends Component {
  static contextTypes = {
    ...actionContextTypes,
  }

  static defaultProps = DEFAULT_PROPS

  render() {
    let { text, onSubmit, submitting, disabled } = this.props
    const { getApp } = this.context
    const { branding } = getApp()
    const { wrapperStyles, textStyles } = getStyles(this.props, branding)

    text = text || 'SAVE'

    return (
      <TouchableOpacity
        style={styles.buttonWrapper}
        onPress={onSubmit}
        disabled={disabled}
      >
        <View style={[styles.button, wrapperStyles]}>
          <Text style={[styles.buttonText, textStyles]}>{text}</Text>
        </View>
        {submitting && <ButtonProgressIndicator />}
      </TouchableOpacity>
    )
  }
}

export class SecondaryButton extends Component {
  static contextTypes = {
    ...actionContextTypes,
  }

  static defaultProps = {
    ...DEFAULT_PROPS,
    backgroundColor: '@background',
    color: '@text',
    fontFamily: '@body',
    fontWeight: '500',
    borderWidth: 1,
    borderColor: '#999',
  }

  render() {
    const { object, disabled, text, action, submitting } = this.props
    const { getApp } = this.context
    const { branding } = getApp()

    const { wrapperStyles, textStyles } = getStyles(this.props, branding)
    const actionKey = action?.actionId
    const actionObject = actionKey ? object.actions[actionKey] : undefined

    return (
      <ActionWrapper
        style={styles.buttonWrapper}
        disabled={disabled}
        actions={[action]}
        object={{ ...object, actions: { [actionKey]: actionObject } }}
      >
        <View style={[styles.button, wrapperStyles]}>
          <Text style={[styles.buttonText, textStyles]}>{text}</Text>
        </View>
        {submitting && <ButtonProgressIndicator />}
      </ActionWrapper>
    )
  }
}

const styles = StyleSheet.create({
  button: {
    height: 40,
    borderRadius: 4,
    backgroundColor: '#000',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonWrapper: {
    marginTop: 35,
  },
  buttonText: {
    textAlign: 'center',
  },
  submitProgress: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
})
